export const agentSpeaks = ({ languages_spoken: languages }, language) => !!languages.find((spoken) => spoken === language)

export const extractFirst = (json) => {
  if (json.count && json.count === 1) {
    return json.results[0]
  } else {
    return json
  }
}

export const trace = (message, tracer = console.log) => {
  return (arg) => {
    tracer(message)
    return arg
  }
}

export const translationChange = (translationA, translationB) => {
  if (translationA !== translationB && (!translationA || !translationB)) {
    return true
  }
  return translationA.delivered !== translationB.delivered || translationA.id !== translationB.id
}

export const isDiff = (objA, objB) => {
  return JSON.stringify(objA) !== JSON.stringify(objB)
}

export const fetchWrapper = (fetchPromise, postProcessor = null, json = true) => {
  return fetchPromise
    .then((response) => {
      if (response.ok) {
        return response
      } else {
        throw response
      }
    })
    .then((response) => {
      if (json) {
        response = response.json()
      }

      if (postProcessor) {
        return postProcessor(response)
      } else {
        return response
      }
    })
}



// WEBPACK FOOTER //
// ./src/utils.js